import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Calendar, Users, MapPin, FileText } from 'lucide-react';

export const MobileTabBar = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const tabItems = [
    { path: '/lessons', label: 'Lezioni', icon: Calendar },
    { path: '/athletes', label: 'Atleti', icon: Users },
    { path: '/venues', label: 'Strutture', icon: MapPin },
    { path: '/reports', label: 'Report', icon: FileText },
  ];

  return (
    <nav 
      className="md:hidden fixed-bar fixed-bottom-bar bg-zinc-900/95 backdrop-blur-xl border-t border-white/10 z-50 mobile-tab-bar overflow-hidden"
      data-testid="mobile-tab-bar"
    >
      <div className="flex items-center justify-around h-full px-2">
        {tabItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <Link 
              key={item.path} 
              to={item.path}
              data-testid={`tab-${item.label.toLowerCase()}`}
              className={`
                flex flex-col items-center justify-center flex-1 h-full gap-1 px-1 pt-4
                transition-all duration-200
                ${active 
                  ? 'text-[#ccff00]' 
                  : 'text-zinc-500 hover:text-zinc-300'
                }
              `}
            >
              <div className={`
                p-2.5 rounded-xl transition-all duration-200
                ${active ? 'bg-[#ccff00]/15' : ''}
              `}>
                <Icon className={`w-6 h-6 ${active ? 'stroke-[2.5]' : 'stroke-[1.5]'}`} />
              </div>
              <span className={`text-sm font-medium leading-none ${active ? 'text-[#ccff00]' : ''}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
